import { getSemesterMonths, getMaxPoints } from "../utils";
import styles from "../GradesPage.module.css";

const GradesTable = ({
	students,
	selectedSemester,
	grades,
	classGradeLevel,
	isEditable,
	onGradeCellClick,
	calculateTotal,
}) => {
	const semesterMonths = getSemesterMonths(selectedSemester);

	return (
		<div className={styles.gradesTableContainer}>
			<div className={styles.gradesTable}>
				<div className={styles.tableHeader}>
					<div className={styles.studentNameColumn}>Student</div>
					{semesterMonths.map((month) => (
						<div key={month.id} className={styles.monthColumn}>
							<span className={styles.monthName}>{month.short}</span>
							<span className={styles.monthMaxPoints}>
								/{getMaxPoints(classGradeLevel, month.id)} pts
							</span>
						</div>
					))}
					<div className={styles.totalColumn}>Total</div>
				</div>

				<div className={styles.tableBody}>
					{students.map((student) => (
						<div key={student.id} className={styles.studentRow}>
							<div className={styles.studentNameCell}>
								<span className={styles.studentName}>{student.name}</span>
								<span className={styles.studentId}>{student.studentId}</span>
							</div>

							{semesterMonths.map((month) => {
								const monthGrade = grades[student.id]?.[month.id];
								const maxPoints = getMaxPoints(classGradeLevel, month.id);
								const hasGrades = monthGrade && monthGrade.total > 0;

								const isLowGrade =
									monthGrade && monthGrade.total / maxPoints < 0.5;

								return (
									<div
										key={month.id}
										className={`${styles.gradeCell} ${
											isEditable ? styles.editable : ""
										} ${hasGrades ? styles.hasGrades : styles.noGrades} ${
											isLowGrade ? styles.lowGrade : ""
										}`}
										onClick={() => {
											if (isEditable && onGradeCellClick) {
												onGradeCellClick(student.id, month.id);
											}
										}}
									>
										<span className={styles.gradeValue}>
											{monthGrade?.total || 0}
										</span>
										<span className={styles.gradeMax}>/{maxPoints}</span>
									</div>
								);
							})}

							<div className={styles.totalCell}>
								<span className={styles.totalValue}>
									{calculateTotal(student.id)}
								</span>
								<span className={styles.totalMax}>/100</span>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default GradesTable;
